// @ts-nocheck
import React, { useEffect, useState } from "react";
import { generateClient } from "aws-amplify/api";
import { listLoginAccessCodes } from "../../graphql/queries";
import {
  createLoginAccessCodes,
  deleteLoginAccessCodes,
} from "../../graphql/mutations";

const initialState = {
  accessCode: "",
  recipient: "",
  notes: "",
};

const client = generateClient();

const LoginAccessCodes = () => {
  const [accessCodeForm, setAccessCodeForm] = useState(initialState);
  const [error, setError] = useState("");
  const [listAccessCodes, setListAccessCodes] = useState([]);

  const fetchAccessCodes = async () => {
    try {
      const { data } = await client.graphql({
        query: listLoginAccessCodes,
      });
      setListAccessCodes(data.listLoginAccessCodes.items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAccessCodes();
  }, []);

  const generateRandomString = (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const handleGenerateCode = () => {
    const randomString = generateRandomString(12);
    setAccessCodeForm({
      ...accessCodeForm,
      accessCode: randomString,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (accessCodeForm.accessCode.length < 11) {
      setError("access codes should be at least 12 characters");
      return;
    }
    if (accessCodeForm.recipient.length < 3) {
      setError("Recipient Required Pal");
      return;
    }
    setError("");

    const form2Submit = {
      ...accessCodeForm,
      code: accessCodeForm.accessCode,
      available: true,
      activatedBy: "",
    };
    delete form2Submit.accessCode;

    const { data } = await client.graphql({
      query: createLoginAccessCodes,
      variables: {
        input: form2Submit,
      },
    });

    setListAccessCodes([data.createLoginAccessCodes, ...listAccessCodes]);
    setAccessCodeForm(initialState);
  };

  const handleDelete = async (code) => {
    const { data } = await client.graphql({
      query: deleteLoginAccessCodes,
      variables: {
        input: { code },
      },
    });

    const deleteItem = data.deleteLoginAccessCodes;

    const filteredAccessCodes = listAccessCodes.filter(
      (cody) => cody.code !== deleteItem.code
    );
    setListAccessCodes(filteredAccessCodes);
  };

  return (
    <div>
      <div className="mb-6">
        <div className="text-gray-900 text-md font-semibold font-Inter mb-4">Create New Access Code</div>
        {error.length > 0 && <div className="text-red-500 mb-4 p-2 bg-red-50 rounded">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Access Code
              </label>
              <div className="flex">
                <input
                  className="shadow-sm border border-gray-300 rounded-md py-2 px-3 w-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  value={accessCodeForm.accessCode}
                  onChange={(e) =>
                    setAccessCodeForm({
                      ...accessCodeForm,
                      accessCode: e.target.value,
                    })
                  }
                />
                <button
                  type="button"
                  onClick={handleGenerateCode}
                  className="ml-2 px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  Generate
                </button>
              </div>
            </div>
            
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Recipient
              </label>
              <input
                className="shadow-sm border border-gray-300 rounded-md py-2 px-3 w-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                value={accessCodeForm.recipient}
                onChange={(e) =>
                  setAccessCodeForm({
                    ...accessCodeForm,
                    recipient: e.target.value,
                  })
                }
              />
            </div>
            
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Notes
              </label>
              <input
                className="shadow-sm border border-gray-300 rounded-md py-2 px-3 w-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                value={accessCodeForm.notes}
                onChange={(e) =>
                  setAccessCodeForm({
                    ...accessCodeForm,
                    notes: e.target.value,
                  })
                }
              />
            </div>
          </div>
          
          <div className="flex justify-end">
            <button 
              className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              type="submit"
            >
              Create Access Code
            </button>
          </div>
        </form>
      </div>
      
      <div className="mt-8">
        <div className="text-gray-900 text-md font-semibold font-Inter mb-4">Access Codes</div>
        <div className="overflow-x-auto bg-white rounded-md">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Access Code</th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Recipient</th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Activated By</th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Available</th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notes</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {listAccessCodes.map((accesscode) => (
                <tr key={accesscode.code} className="hover:bg-gray-50">
                  <td className="px-4 py-2 whitespace-nowrap">
                    <button
                      disabled={!accesscode.available}
                      onClick={() => handleDelete(accesscode.code)}
                      className={`px-3 py-1 text-sm rounded-md ${
                        accesscode.available
                          ? "bg-red-100 text-red-700 hover:bg-red-200"
                          : "bg-gray-100 text-gray-400 cursor-not-allowed"
                      }`}
                    >
                      Delete
                    </button>
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{accesscode.code}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{accesscode.recipient}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{accesscode.activatedBy || "—"}</td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      accesscode.available ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"
                    }`}>
                      {accesscode.available ? "Yes" : "No"}
                    </span>
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{accesscode.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LoginAccessCodes;
